import { urlConfig } from './../config/url.config';
import { Component, HostListener, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, Event, ActivatedRoute } from '@angular/router';
import { CmsService } from './shared/services/cms/cms.service';
import { PageService } from './shared/services/page.service';
import { StorageModule } from './shared/utils/storage.module';
import * as Bowser from "bowser";
import { FaqItem } from './shared/model/faq-model';
import { get } from 'lodash';
import { NetworkService } from './shared/services/network.service';
import { MonitoringService } from './shared/services/monitoring.service';
import { environment } from '../environments/environment';
import { CMS_PAGE_ID } from './shared/enum/cms-page-id.enum';
import { CMSConfigModel } from './shared/model/cmsConfigs.model';
import { map } from 'rxjs/operators';
import { ROUTES } from './shared/utils/routes';
import { Location } from "@angular/common";

const ROUTES_TO_SKIP_GA_INJECTION =[
    ROUTES.fraude_face_biometry.path,
    'pagina-nao-encontrada'
  ]

  const ROUTES_TO_SKIP_DEFAULT_PAGEVIEW =[
    ROUTES.identity_recovery.path,
    ROUTES.offer_card_flow.path,
    ROUTES.offer_card_unified.path,
    ROUTES.offer_overdraft.path,
    ROUTES.offer_package.path,
    ROUTES.fraude_face_biometry.path,
    ROUTES.step_finish.path,
    ROUTES.fraude_doc_documents.path,
    ROUTES.fraude_doc_documents_capture.path
  ]

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'mob-fopa-spa-onboarding-link';
  themeChangedSub: any;
  currentFaqItems: Array<FaqItem> = [];
  wasOffline: boolean = false;
  showErrorViewer = false;
  LOAD = true;
  appInitializedUrl = window.location.pathname;

  urlsToIgnore = [
    ROUTES.identification.url,
    ROUTES.token_validation.url,
  ]

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const osName = this.pageService.deviceInfo;
     this.pageService.isMobile =
            osName?.os?.name?.toLowerCase().indexOf("android") > -1 ||
            osName?.os?.name?.toLowerCase().indexOf("ios") > -1;
  }

  constructor(public cmsService: CmsService,
    public storage: StorageModule,
    public networkService: NetworkService,
    public pageService: PageService,
    public router: Router,
    public monitoring: MonitoringService,
    public activatedRoute: ActivatedRoute,
    private location: Location,
    ) {

    this.injectScripts();

    router.events.subscribe((event: Event) => {

      if (event instanceof NavigationStart) {
        // Show loading indicator
        this.pageService.isPageLoading = true;
        this.pageService.loadingTextTitle = 'Carregando';
      }

      if (event instanceof NavigationEnd) {

        this.monitoring.checkDatalayerDimension();

        if (this.activatedRoute.firstChild.children.length > 0) {
          const routeData = this.activatedRoute.firstChild.children[0].snapshot.data;

          // configurar faq do step
          // verify is isMono proposal
          const isMono = this.storage.getIsMono();
          if (isMono) {
            this.currentFaqItems = get(routeData, 'cmsPage.step.faqs', []).filter(faqItem => faqItem.isMono);
          }
          else{
            // All mar-aberto faq items
            this.currentFaqItems = get(routeData, 'cmsPage.step.faqs', []).filter(faqItem => !faqItem.isMono);
          }

          const skipScriptInjection =   ROUTES_TO_SKIP_GA_INJECTION.includes(routeData.route.path) &&
                                        this.appInitializedUrl.indexOf('/'+routeData.route.path);

          // Check if current route is the first route loaded
          if(!skipScriptInjection){
            this.loadGTM();
          }

          const customPageViewRoute = ROUTES_TO_SKIP_DEFAULT_PAGEVIEW.includes(routeData.route.path);

          // Send data to analytics
          if (!customPageViewRoute) {
            monitoring.send(routeData.route.path);
          }

        }

        // Hide loading indicator
        this.pageService.isPageLoading = false;
      }
    });
  }

  ngOnInit() {
    const actualUrl = this.location.path().slice(1);
    if (!this.urlsToIgnore.includes(actualUrl) && urlConfig.dlb_crypt === 'sim' && !actualUrl.includes(ROUTES.identification.url)) {
        this.pageService.goToPage(ROUTES.identification.url)
    }
    this.showErrorViewer = environment.showError === 'SIM';
    this.themeChangedSub = this.pageService.themeChanged.subscribe(ev => {
      const themeName = this.pageService.themeColor;
      const isDarkTheme = themeName === 'dark';
      const previous = isDarkTheme ? 'light' : 'dark';

      // clear previous theme class
      if (document.querySelector('body').classList.contains(`theme-${previous}`)) {
        document.querySelector('body').classList.remove(`theme-${previous}`);
      }
      // then adds new theme css class
      document.querySelector('body').classList.add(`theme-${themeName}`);
    })

    this.pageService.setLightTheme();

    this.onResize({});
    this.loadSubscriptions();
  }

  ngOnDestroy() {
    if (this.themeChangedSub) {
      this.themeChangedSub.unsubscribe();
    }
  }

  loadSettings(){
    return this.cmsService.getPageDetail(CMS_PAGE_ID.pageSettings)
    .pipe(map(response=>{
      const { dynatrace, optimize, emailConfirmation, openFinance, limitValue, university, correios, unicoSdk, samsungCap, keyName, sdkVerification } = new CMSConfigModel( response.step);

      this.storage.setConfigs({ dynatrace, optimize, emailConfirmation, openFinance, limitValue, university, correios, unicoSdk, samsungCap, keyName, sdkVerification });
      return { dynatrace, optimize };
    }));

  }
  //load scripts
  injectScripts() {
    this.loadSettings()
      .subscribe( settingsFlags => {
       if (!settingsFlags) return this.loadScripts();
        const load = this.filterFlags(settingsFlags);
        return this.loadScripts(load);
      }, () => this.loadScripts())
  }

  filterFlags(settingsFlags) {

    if (!settingsFlags) return this.loadScripts();

    const { biometry,dynatrace, optimize } = settingsFlags;

    const loadOptimize = optimize ? optimize.value === "Y": false;
    const loadDynatrace =  dynatrace  ? dynatrace.value === "Y" : false;
    //const loadbiometry =  biometry && biometry.value.length > 0 ? biometry.value : "";

    return { loadOptimize, loadDynatrace };

  }

  loadScripts(load?) {
    this.loadGoogleOptimize(load ? load.loadOptimize : this.LOAD);
    this.storage.setDynatraceStatus(load ? load.loadDynatrace : this.LOAD);
  }

  loadGoogleOptimize(load: boolean) {
    if (load) {
      const script = document.createElement('script');
      script.src = `https://www.googleoptimize.com/optimize.js?id=${environment.key_optimize}`;
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }

  private loadSubscriptions(countOfTries: number = 0) {
    this.pageService.isPageLoading = true;
    const script = document.createElement("script");
    script.src = `${environment.cardsElementUrl}/main.js`;
    script.onerror = () => {
        script.remove();
        setTimeout(() => {
            if (countOfTries < 4) {
                this.pageService.updateValues({ title: 'Carregando', subtitle: "Aguarde mais alguns instantes ..." });
                this.loadSubscriptions(countOfTries + 1);
            }
            else {
                this.pageService.goToPage(ROUTES.errorGeneric.url);
            }
        }, 1000);
    }

    script.onload = () => {
        this.pageService.isPageLoading = false;
    }

    document.body.append(script);
}

loadGTM() {

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', '` + environment.id_google_tag_manager + `');`;
    document.getElementsByTagName('body')[0].appendChild(script);
  }

}
